import type { IListResponse } from "~/types/IListResponse";
import { isInteger } from "./numbers";

/** Magazine authors dialog loads this many authors per scroll. */
export const MAGAZINE_AUTHORS_PAGE_SIZE = 50;

/** Same cap as the paged `/authors` route. */
export const AUTHORS_PAGE_MAX_LIMIT = 100;

export type AuthorsPaginationQuery = {
  offset?: unknown;
  limit?: unknown;
};

export function parseAuthorsPaginationQuery(
  query: AuthorsPaginationQuery
): { offset: number; limit: number } {
  let offset = 0;
  if (query.offset !== undefined) {
    if (!isInteger(query.offset) || Number(query.offset) < 0) {
      throw new Error(
        "'offset' query parameter must be a non-negative integer"
      );
    }
    offset = parseInt(String(query.offset), 10);
  }

  let limit = MAGAZINE_AUTHORS_PAGE_SIZE;
  if (query.limit !== undefined) {
    if (!isInteger(query.limit) || Number(query.limit) <= 0) {
      throw new Error("'limit' query parameter must be a positive integer");
    }
    if (Number(query.limit) > AUTHORS_PAGE_MAX_LIMIT) {
      throw new Error("max limit should be 100");
    }
    limit = parseInt(String(query.limit), 10);
  }

  return { offset, limit };
}

export function appendAuthorPage<T>(
  current: {
    researchTopicId: number | null;
    authors: T[];
    total: number;
  },
  researchTopicId: number,
  page: Pick<IListResponse<T>, "items" | "total">
): { researchTopicId: number; authors: T[]; total: number } {
  const sameTopic = current.researchTopicId === researchTopicId;
  return {
    researchTopicId,
    authors: sameTopic
      ? [...current.authors, ...page.items]
      : [...page.items],
    total: page.total
  };
}
